import { AccountScreen } from 'common/accountActivationAndRecovery/AccountScreen';

import { DEVICE_HANDOFF_PATH } from './state/constants';

export const DeviceHandoffScreenSegment = {
    [AccountScreen.Login]: '',
    [AccountScreen.ForgotUser]: 'forgotUser',
    [AccountScreen.SecurityQuestion]: 'securityQuestion',
    [AccountScreen.SecurityAnswer]: 'securityAnswer',
    [AccountScreen.CreatePassword]: 'createPassword',
    [AccountScreen.Activation]: 'activation',
    [AccountScreen.Policy]: 'policy',
} as const satisfies Record<AccountScreen, string>;

export function deviceHandoffScreenPath(screen: AccountScreen): string {
    const segment = DeviceHandoffScreenSegment[screen];
    return segment ? `${DEVICE_HANDOFF_PATH}/${segment}` : DEVICE_HANDOFF_PATH;
}
